/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmUserauthV1RoleState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_USERAUTH_V1_ROLE_STATE_ENTITY_NAME = 'ixm.userauth.v1.Role';
export const ixmUserauthV1RoleStateEntity = new schema.Entity<IxmUserauthV1RoleState>(IXM_USERAUTH_V1_ROLE_STATE_ENTITY_NAME, {}, { idAttribute: 'roleId' });

